import { call, put, takeEvery } from 'redux-saga/effects';
import {
  getBranchesApi,
  getBranchByIdApi,
  createBranchApi,
  updateBranchApi,
  deleteBranchApi,
} from '../../api/BranchApi';
import {
  getBranchSuccess,
  getBranchFailure,
  createBranchSuccess,
  createBranchFailure,
  updateBranchSuccess,
  updateBranchFailure,
  deleteBranchSuccess,
  deleteBranchFailure,
} from './actions';

// branchSaga.ts
function* fetchBranchesSaga(action: any): Generator<any, any, any> {
  try {
    const { page, size, search } = action.payload;
    const response = yield call(getBranchesApi, { page, size, search });
    
    // Ensure we have a proper data structure
    const normalizedData = {
      data: Array.isArray(response.data.data) ? response.data.data : [],
      pagination: response.data.pagination || { total: 0 }
    };
    
    yield put(getBranchSuccess(normalizedData));
  } catch (error: any) {
    const errorMessage = error?.response?.data?.meta?.message || 
                        error?.message || 
                        'Failed to fetch branches';
    yield put(getBranchFailure(errorMessage));
  }
}

// Create Branch Saga
function* createBranchSaga(action: any): Generator<any, any, any> {
  try {
    const response = yield call(createBranchApi, action.payload);
    yield put(createBranchSuccess(response));
  } catch (error: any) {
    const errorMessage = error?.response?.data?.meta?.message 
      || error?.message 
      || 'Failed to create branch';
    yield put(createBranchFailure(errorMessage));
  }
}

// Update Branch Saga
function* updateBranchSaga(action: any): Generator<any, any, any> {
  try {
    const { id, data } = action.payload;
    const response = yield call(updateBranchApi, data, id);
    yield put(updateBranchSuccess(response));
  } catch (error: any) {
    const errorMessage = error?.response?.data?.meta?.message 
      || error?.message 
      || 'Failed to update branch';
    yield put(updateBranchFailure(errorMessage));
  }
}

// Delete Branch Saga
function* deleteBranchSaga(action: any): Generator<any, any, any> {
  try {
    const { id } = action.payload;
    const response = yield call(deleteBranchApi, id);
    yield put(deleteBranchSuccess(response));
  } catch (error: any) {
    const errorMessage = error?.response?.data?.meta?.message 
      || error?.message 
      || 'Failed to delete branch';
    yield put(deleteBranchFailure(errorMessage));
  }
}

export default function* branchSaga() {
  yield takeEvery('GET_BRANCH_REQUEST', fetchBranchesSaga);
  yield takeEvery('CREATE_BRANCH_REQUEST', createBranchSaga);
  yield takeEvery('UPDATE_BRANCH_REQUEST', updateBranchSaga);
  yield takeEvery('DELETE_BRANCH_REQUEST', deleteBranchSaga);
}